import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-free-form-line-style-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-line-style-form.component.html',
    styleUrls: ['./free-form-line-style-form.component.scss'],
    standalone: false
})
export class FreeFormLineStyleFormComponent {
  #isSubmitted = signal(false);
  #freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyle;
  freeFormStyleForm = new FormGroup(
    {
      strokeColor: new FormControl(''),
      strokeWidth: new FormControl(1),
      dash: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.FreeFormStyleEntityModels.FreeFormStyleSchema.pick({
          strokeColor: true,
          strokeWidth: true,
          dash: true,
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Free Form Style
    this.slideAuthorFacade.currentSelectedSlideFreeFormStyle$.pipe(takeUntilDestroyed()).subscribe((freeFormStyle) => {
      this.#freeFormStyle = structuredClone(freeFormStyle);
      if (freeFormStyle) {
        this.freeFormStyleForm.reset(this.#freeFormStyle);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.freeFormStyleForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const freeFormStyle = assign(this.#freeFormStyle, this.freeFormStyleForm.value);
    this.slideAuthorFacade.requestUpdateFreeFormStyle(freeFormStyle, 'history.free_form_update_style').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.freeFormStyleForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
